import React, { useState, useEffect } from 'react';
import { Popup, Input, Dropdown, Button, Grid, Image, Form, Divider } from 'semantic-ui-react';

const TipPopup = ({
    isMobile,
    tipAmount,
    setIsCustomTipActive,
    addTip,
}) => {
    // Local state for custom tip input
    const [customTipAmount, setCustomTipAmount] = useState('');
    const [customTipType, setCustomTipType] = useState('$');

    if (tipAmount > 0) return null;

    const tipOptions = [
        { key: '$', text: '$', value: '$' },
        { key: '%', text: '%', value: '%' },
    ];

    return (
        <Popup
            trigger={
                <Image
                    src="/assets/tip.png"
                    alt="Add Tip"
                    title="Add Tip"
                    style={{
                        cursor: 'pointer',
                        width: '30px',
                        height: '30px',
                        padding: '4px',
                        background: 'transparent'
                    }}
                />
            }
            position={isMobile ? 'left center' : 'top center'}
            on={isMobile ? 'click' : ['click', 'hover']}
            hoverable={!isMobile}
            flowing={isMobile}
            hideOnScroll={isMobile}
            style={isMobile ? { zIndex: 9999 } : {}}
            content={
                <div
                    style={{
                        width: isMobile ? '220px' : '335px',
                        maxWidth: isMobile ? '90vw' : '400px',
                        padding: isMobile ? '8px' : '10px',
                        fontSize: isMobile ? '12px' : '14px',
                    }}
                >
                    {/* Custom Input Section */}
                    <Form>
                        <Form.Field>
                            <label
                                style={{
                                    fontWeight: 'bold',
                                    fontSize: isMobile ? '11px' : '14px',
                                    marginBottom: '4px',
                                }}
                            >
                                Custom:
                            </label>
                            <Input
                                placeholder={isMobile ? 'Amount' : 'Custom Amount'}
                                value={customTipAmount}
                                onChange={(e) => {
                                    setCustomTipAmount(e.target.value);
                                    setIsCustomTipActive(true);
                                }}
                                type="number"
                                action
                                fluid
                                size={isMobile ? 'small' : 'medium'}
                            >
                                <input />
                                <Dropdown
                                    text={customTipType || '$'}
                                    value={customTipType || '$'}
                                    compact
                                    selection
                                >
                                    <Dropdown.Menu className="custom-popup-menu">
                                        {tipOptions.map((item) => (
                                            <Dropdown.Item
                                                key={item.key}
                                                text={item.text}
                                                value={item.value}
                                                onClick={() => {
                                                    setCustomTipType(item.value);
                                                    setIsCustomTipActive(true);
                                                }}
                                            />
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                                <Button
                                    className="btn btn-primary"
                                    size={isMobile ? 'tiny' : 'small'}
                                    onClick={() => {
                                        if (customTipAmount && customTipAmount > 0) {
                                            addTip(parseFloat(customTipAmount), customTipType === '%');
                                            setCustomTipAmount('');
                                            setCustomTipType('$');
                                        }
                                    }}
                                >
                                    Add
                                </Button>
                            </Input>
                        </Form.Field>
                    </Form>
                    {!isMobile ? <><Divider horizontal>Or</Divider>
                        {/* Dollar Tip Buttons */}
                        <Grid columns={3} stackable style={{ marginTop: '6px' }}>
                            {[5, 10, 20].map((amount) => (
                                <Grid.Column key={amount}>
                                    <Button
                                        basic
                                        size={isMobile ? 'tiny' : 'small'}
                                        fluid
                                        onClick={() => addTip(amount)}
                                    >
                                        ${amount}
                                    </Button>
                                </Grid.Column>
                            ))}
                        </Grid>

                        {/* Percentage Tip Buttons */}
                        <Grid columns={3} stackable style={{ marginTop: '6px' }}>
                            {[5, 10, 20].map((percent) => (
                                <Grid.Column key={percent}>
                                    <Button
                                        basic
                                        size={isMobile ? 'tiny' : 'small'}
                                        fluid
                                        onClick={() => addTip(percent, true)}
                                    >
                                        {percent}%
                                    </Button>
                                </Grid.Column>
                            ))}
                        </Grid></> : null}
                    
                    {/* Warning message */}
                    <div style={{ 
                        marginTop: '10px', 
                        padding: '8px', 
                        backgroundColor: '#fff3cd', 
                        borderLeft: '3px solid #ffc107',
                        fontSize: isMobile ? '10px' : '12px',
                        color: '#856404'
                    }}>
                        <strong>⚠️ Note:</strong> Payment Plan and Subscription options are not available when tip is added.
                    </div>
                </div>
            }
        />
    );
};

export default TipPopup;
